<!--
 * @Author: liuqing
 * @Date: 2021-01-12 16:19:28
 * @LastEditors: liuqing
 * @LastEditTime: 2021-01-12 17:08:59
 * @Description: 页面顶部温馨提示
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
-->

<template>
  <div class="top-tip-container" :style="styleObj">
    <div class="left">
      <span>{{ title }}</span>
      <span>{{ message }}</span>
    </div>
    <div class="right" @click="hancleClick">
      <span>{{ operateText }}</span>
      <span class="icon iconfont">&#xe611;</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopTip",
  props: {
    title: {
      type: String,
      default: "温馨提示："
    },
    message: {
      type: String,
      required: true
    },
    operateText: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      styleObj: {
        background: "#E3F1FF",
        height: '0.8rem'
      }
    };
  },
  methods: {
    hancleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="less" scoped>
.top-tip-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.32rem;
  width: 100%;
  span {
    font-size: 0.26rem;
  }
  .left, .right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left {
    color: #666;
  }
  .right {
    color: #3296FA;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopTip.vue